import { Star } from 'lucide-react'
import type { Site } from '@/api/accommodation/types'
import { SITE_LABELS, formatRatingValue } from '@/lib/rating'

interface RatingInlineProps {
  sites: Site[] | undefined
}

function reviewsLabel(count: number): string {
  if (count === 1) return 'recenze'
  if (count >= 2 && count <= 4) return 'recenze'
  return 'recenzí'
}

export function RatingInline({ sites }: RatingInlineProps) {
  const valid = sites?.filter(
    (s): s is Site & { ratingValue: number; ratingCount: number } =>
      s.ratingValue !== null && s.ratingCount !== null && s.ratingCount > 0,
  )
  if (!valid || valid.length === 0) return null

  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-1">
      {valid.map((s) => (
        <div key={s.site} className="flex items-center gap-1.5 text-sm">
          <Star className="h-4 w-4 shrink-0 fill-amber-400 text-amber-400" />
          <span className="font-semibold text-slate-900">{formatRatingValue(s.ratingValue)}</span>
          <span className="text-slate-500">
            {SITE_LABELS[s.site]} ({s.ratingCount}&nbsp;
            {reviewsLabel(s.ratingCount)})
          </span>
        </div>
      ))}
    </div>
  )
}
